import { render, staticRenderFns } from "./promote-office-to-sc-modal.vue?vue&type=template&id=e4b3bc72&"
import script from "./promote-office-to-sc-modal.vue?vue&type=script&lang=js&"
export * from "./promote-office-to-sc-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports